import React from 'react';

function Banner2({
  children,
  className,
  type,
  open,
  setOpen,
  showClose = true
}) {
  const typeColor = (type) => {
    switch (type) {
      case 'primary':
        return 'border border-violet-200 bg-violet-100/70 text-slate-800';
      case 'secondary':
        return 'border border-slate-300 bg-slate-100 text-slate-800';
      case 'warning':
        return 'border border-orange-200 bg-orange-50 text-orange-700';
      case 'danger':
      case 'error':
        return 'border border-red-300 bg-red-100/70 text-red-900 dark:border-red-700 dark:bg-red-950/40 dark:text-red-100';
      case 'success':
        return 'border border-emerald-200 bg-emerald-50 text-slate-800';
      case 'info':
        return 'border border-sky-200 bg-sky-50 text-slate-800';
      case 'light':
        return 'border border-slate-200 bg-white text-slate-800';
      case 'dark':
        return 'border border-slate-900 bg-slate-900 text-white';
      default:
        return 'border border-violet-200 bg-violet-100/70 text-slate-800';
    }
  };

  return (
    <>
      {open &&
        <div className={className} role="alert">
          <div className={`rounded-xl px-4 py-3 text-sm ${typeColor(type)}`}>
            <div className="flex w-full justify-between items-start">
              <div className="min-w-0 flex-1">
                  {children}
              </div>
              {showClose && (
                  <button className="opacity-60 hover:opacity-70 ml-3 mt-[3px]" onClick={() => setOpen(false)}>
                    <div className="sr-only">Close</div>
                    <svg className="fill-current" width="16" height="16" viewBox="0 0 16 16">
                      <path
                          d="M7.95 6.536l4.242-4.243a1 1 0 111.415 1.414L9.364 7.95l4.243 4.242a1 1 0 11-1.415 1.415L7.95 9.364l-4.243 4.243a1 1 0 01-1.414-1.415L6.536 7.95 2.293 3.707a1 1 0 011.414-1.414L7.95 6.536z"/>
                    </svg>
                  </button>
              )}
            </div>
          </div>
        </div>
      }
    </>
  );
}

export default Banner2;
